
import 'assets/css/react-datetime.css';
import DefaultFooter from "components/Footers/DefaultFooter.js";
import TSText from "components/Forms/TSText.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import React, { useState, useContext } from "react";
import Datetime from 'react-datetime';
import { useDropzone } from 'react-dropzone';
// reactstrap components
import {
    Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Modal, ModalBody, Nav, NavItem, NavLink, Row, TabContent, TabPane,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown
} from "reactstrap";
import { authHeader, handleResponse } from '_helpers';
import { authenticationService } from '_services';


const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    maxWidth: '150px',
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: 'auto',
};

//function TelePage2() {
const TelePageInfo = (props) => {
    const teleID = (props.match.params.teleID !== undefined) ? props.match.params.teleID : null;

    const [dateFocus, setDateFocus] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modalPayment, setModalPayment] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [renderCost, setRenderCost] = useState([]);
    const [renderDrug, setRenderDrug] = useState([]);
    const [totalCost, setTotalCost] = useState([]);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [modalLine, setModalLine] = useState(false);
    const [modalTrack, setModalTrack] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [UserID, setUserID] = useState("");
    const [ServiceType, setType] = useState("");
    const [AppointDatetime, setDate] = useState("");
    const [Phone, setPhone] = useState("");
    const [LineID, setLine] = useState("");
    const [LineProfile, setLineProfile] = useState([]);
    const [LineTrangskin, setLineTrangskin] = useState("");
    const [FlowStatus, setFlowStatus] = useState(0);
    const [ShippingAddress, setAddress] = useState("");
    const [Description, setDescription] = useState("");
    const [Id, setId] = useState("");
    const [FileData, setFileData] = useState("");

    const [FullName, setFullName] = useState("");
    const [HN, setHN] = useState("");

    const [PaymentMsg, setPaymentMsg] = useState("");

    const [files, setFiles] = useState([]);
    const [iconPills, setIconPills] = React.useState("0");
    const [pills, setPills] = React.useState("1");

    const [Tracking, setTracking] = React.useState([]);
    const [Tracking1, setTracking1] = React.useState("");
    const [Tracking2, setTracking2] = React.useState("");
    const [Tracking3, setTracking3] = React.useState("");

    const currentUser = authenticationService.currentUserValue;

    /*
    const liff = window.liff;
        liff.init({
            liffId: '1654063801-PwXBy90W'
        })
        .then(() => {

            if (liff.isLoggedIn()) {
                
                liff.getProfile().then(function (profile) {

                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                                //this.props.history.push(from);
                                //window.alert(user)
                            },
                            error => {
                                console.log(error);
                            }
                    );

                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });
                
            }
        })
        .catch((err) => {

        });
    */
    const urls = [
        '/api/v1/tele/info/' + teleID
    ];

    React.useEffect(() => {
        //check login
        console.log(currentUser);
        if (!currentUser) {
            window.location.assign('/login');
        }

        /*
        Promise.all(urls.map(url =>
            fetch(url, { headers: authHeader()})
                //.then(checkStatus)
                .then(handleResponse)
                .catch(err => console.log(err))
        ))
        .then(data => {
            var data1 = data[0].data;
            var data2 = data[1];

            setDate(data1.appointDatetime)
            setType(data1.serviceType)
            setPhone(data1.phone)
            setAddress(data1.shippingAddress)
            setDescription(data1.description)
            setLine(data1.lineID)

            setRenderCost(data2.costList)
            setTotalCost(data2.costTotal)
        })
        .catch(err => console.log(err))
        */


        fetch('/api/v1/tele/info/' + teleID, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    console.log(result)
                    setFullName(result.profile.firstName + ' ' + result.profile.lastName)
                    setHN(result.profile.hn)
                    setLineTrangskin(result.profile.lineTrangskin)
                    setUserID(result.tele.userID);
                    setDate(result.tele.appointDatetime)
                    setType(result.tele.serviceType)
                    setPhone(result.tele.phone)
                    setFlowStatus(result.tele.flowStatus)
                    setAddress(result.tele.shippingAddress)
                    setDescription(result.tele.description)
                    setLine(result.tele.lineID)
                    setLineProfile(result.lineProfile)

                    setRenderCost(result.costList)
                    setTotalCost(result.costTotal)
                    setRenderDrug(result.drugList)

                    if (result.tele.jsonTrackingNo != null && result.tele.jsonTrackingNo != '')
                        setTracking(JSON.parse(result.tele.jsonTrackingNo));
                    //setFiles(result.image)

                    fetch('/api/v1/tele/imagelist/' + teleID, {
                        method: 'GET',
                        headers: authHeader()
                    })
                        .then(handleResponse)
                        .then(
                            (result) => {
                                setFiles(result.image)
                            },
                            (error) => {
                                //alert(error);
                            }
                        );

                },
                (error) => {
                    //alert(error);
                }
            );


        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);

    const reloadCost = () => {

    }



    var fileTxt = "";

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ));
        }
    });

    async function uploadWithJSON(file) {
        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
        //console.log(file)

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await toBase64(file),
        }

        return await data;
    }

    const trackList = Tracking.map((track, index) =>
        <Row key={index} style={{ fontSize: '1.2em', paddingLeft: ' 1.5em' }}>
            <Col md="12" xs="12" className="text-left">
                Tracking No. : <a href={"https://track.thailandpost.co.th/?trackNumber=" + track.barcode} target="_blank"> {track.barcode} </a>
            </Col>
        </Row>
    );

    const thumbs = files.map(file => (
        //(file.fileCategoryID != 2) ?
        <div style={thumb} key={file.fileName}>
            <div style={thumbInner}>
                <a href={"/images/" + file.fileID} target="_blank">
                    <img
                        src={file.fileSrc}
                        style={img}
                    />
                </a>
            </div>
        </div>
        //: ""
    ));

    const thumbsPay = files.map(file => (
        (file.fileCategoryID == 2) ?
            <div style={thumb} key={file.fileName}>
                <a href={"/images/" + file.fileID} target="_blank">
                    <div style={thumbInner}>
                        <img
                            src={file.fileSrc}
                            style={img}
                        />
                    </div>
                </a>
            </div>
            : ""
    ));

    const handleTrack = (evt) => {
        evt.preventDefault();
        var errCnt = 0;
        var arr = [];

        if (Tracking1 != '') {
            if (Tracking1.length == 13)
                arr.push({ "barcode": Tracking1 })
            else {
                errCnt += 1;

            }
        }

        if (Tracking2 != '') {
            if (Tracking2.length == 13)
                arr.push({ "barcode": Tracking2 })
            else {
                errCnt += 1;
            }
        }

        if (errCnt == 0) {
            if (arr.length > 0) {
                setModalTrack(true);
            }
            else {
                setErrMsg("กรุณาระบุหมายเลข Tracking No.");
                setModalError(true);
            }
        }
        else {
            setErrMsg("หมายเลข Tracking No. ไม่ถูกต้อง");
            setModalError(true);
        }

    }
    const confirmTracking = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


        var errCnt = 0;
        var arr = [];

        if (Tracking1 != '') {
            if (Tracking1.length == 13)
                arr.push({ "barcode": Tracking1 })
            else {
                errCnt += 1;

            }
        }

        if (Tracking2 != '') {
            if (Tracking2.length == 13)
                arr.push({ "barcode": Tracking2 })
            else {
                errCnt += 1;
            }
        }

        if (errCnt == 0) {
            if (arr.length > 0) {

                var json = JSON.stringify(arr);

                const requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json-patch+json',
                        'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                    },
                    body: JSON.stringify({
                        "flowStatus": 6,
                        "jsonTrackingNo": json,
                    })
                };

                fetch('/api/v1/tele/transfer/' + teleID, requestOptions)
                    .then(handleResponse)
                    .then(
                        (result) => {

                            if (result.result != 500) {
                                alert('บันทึกหมายเลข Tracking No. แล้ว');
                                //console.log(JSON.parse(json));
                                setTracking(JSON.parse(json));
                                setModalTrack(false);
                                setIcon("far fa-question-circle");
                            }
                            else {
                                setErrMsg(result.message);
                                setModalError(true);
                            }

                            
                        },
                        (error) => {
                            alert(error);
                        }
                    )

            }
            else {
                setErrMsg("กรุณาระบุหมายเลข Tracking No.");
                setModalError(true);
            }
        }
        else {
            setErrMsg("หมายเลข Tracking No. ไม่ถูกต้อง");
            setModalError(true);
        }

    }


    const handleSubmit = (evt) => {
        evt.preventDefault();

        var cntErr = 0;
        var errMsg = '';


        if (Description == null || Description == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ หรือ อาการเบื้องต้น';
        }

        if (ShippingAddress == null || ShippingAddress == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุที่อยุ่จัดส่งยาทางไปรษณีย์';
        }

        if (Phone == null || Phone == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุหมายเลขโทรศัพท์';
        }

        if (!moment(AppointDatetime).isValid()) {
            cntErr += 1;
            errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
        }

        if (ServiceType == null || ServiceType == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ พบแพทย์หรือรับยาต่อเนื่อง';
        }


        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {
            setModal2(true);
        }
    }

    const handlePayment = (evt) => {
        evt.preventDefault();
        setModalPayment(true);
    }


    const handleNoPay = (evt) => {
        evt.preventDefault();

        if (PaymentMsg != "") {
            handleReplyPayment(evt, -5)
        }
        else {
            alert("กรุณาระบุคำชี้แจงกรณีการส่งหลักฐานชำระเงินของผู้ป่วยผิดพลาด")
        }
    }


    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "serviceType": ServiceType,
                "appointDatetime": AppointDatetime,
                "lineID": LineID,
                "phone": Phone,
                "shippingAddress": ShippingAddress,
                "description": Description,
            })
        };

        fetch('/api/v1/tele/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    alert("บันทึกเรียบร้อยแล้ว")
                    setModal2(false);
                    setIcon("far fa-question-circle");
                },
                (error) => {
                    alert(error);
                }
            )
    }


    const handleTransfer = (evt, flow) => {
        evt.preventDefault();
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "flowStatus": flow,
            })
        };

        fetch('/api/v1/tele/transfer/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    

                    if (result.result != 500) {
                        alert('ส่งต่อแล้ว');
                        if (flow == 5)
                            setModalPayment(false);
                    }
                    else {
                        setErrMsg(result.message);
                        setModalError(true);
                    }
                },
                (error) => {
                    alert(error);
                }
            )
    }


    const handleReplyPayment = (evt, flow) => {
        evt.preventDefault();
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "flowStatus": flow,
                "paymentMsg": PaymentMsg,
            })
        };

        fetch('/api/v1/tele/transfer/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {

                    if (result.result != 500) {
              
                        alert('แจ้งเตือนผู้ป่วยแล้ว');
                        setModalPayment(false);
                        setPaymentMsg("");

                    }
                    else {
                        setErrMsg(result.message);
                        setModalError(true);
                    }
                },
                (error) => {
                    alert(error);
                }
            )
    }

    const handleCallNew = (evt) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };

        fetch('/api/v1/tele/call2/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                   
                    if (result.result != 500) {
                         console.log(result);
                        window.alert("แจ้งเตือนเรียบร้อยแล้ว");
                        //setModalLine(false);

                        //window.open('/admincall/' + teleID, 'Data', 'fullscreen=yes');
                        window.open('https://meet.trangskin.go.th/' + teleID + '?jwt=' + result.token, 'Data', 'fullscreen=yes');
                    }
                    else {
                        setErrMsg(result.message);
                        setModalError(true);
                    }
                },
                (error) => {
                    //alert(error);
                }
            )
    };
    const handleLine = e => {
        setModalMsg('ยืนยันการเรียก\r\nคุณ ' + FullName + ' \r\nเพื่อให้บริการ');
        setModalLine(true);
    };

    const handleLineCall = (evt) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };

        fetch('/api/v1/tele/call/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    
                    if (result.result != 500) {
                        console.log(result);
                        window.alert("แจ้งเตือนเรียบร้อยแล้ว");
                        setModalLine(false);

                        window.open('/vdoadmin/' + teleID, 'Data', 'fullscreen=yes');
                    }
                    else {
                        setErrMsg(result.message);
                        setModalError(true);
                    }
                },
                (error) => {
                    //alert(error);
                }
            )
    };

    const handleCost = () => {
        //console.log(renderCost)
        //console.log(totalCost)
        //console.log(LineTrangskin)

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            }
        };


        fetch('/api/v1/tele/cost/' + teleID, requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                   

                    if (result.result != 500) {
                        console.log(result);
                        window.alert("ส่งยอดค่าใช้จ่ายเรียบร้อยแล้ว");
                    }
                    else {
                        setErrMsg(result.message);
                        setModalError(true);
                    }

                },
                (error) => {

                }
            )
    };

    var moment = require('moment');
    require('moment/locale/th');
    /*
    const contentDrug = renderDrug.map((post, index) =>
        <Row key={index} style={{ fontSize: '1em', borderBottom: '1px solid #dddddd' }}>
            <Col md="9" xs="9" className="text-left">
                <Row><Col><b>{post.itemName}</b></Col></Row>
                <Row><Col>{post.itemNote}</Col></Row>
            </Col>
            <Col md="3" xs="3">
                {post.qty} {post.itemUnitName}
            </Col>
        </Row>
    );
    */
    const contentCost = renderCost.map((post, index) =>
        <Row key={index} style={{ fontSize: '1em', borderBottom: '1px solid #dddddd' }}>
            <Col md="6" xs="6" className="text-left">
                {post.svname}
            </Col>
            <Col md="2" xs="2">
                {post.totcost}
            </Col>
            <Col md="2" xs="2">
                {post.netdisc}
            </Col>
            <Col md="2" xs="2">
                {post.netcost}
            </Col>
        </Row>
    );

    const onSubmit = values => {
        console.log(JSON.stringify(values));
    };

    return (
        <>
            <IndexNavbar />
            <div className="wrapper">
                <IndexHeader />
                <div className="section section-contact-us" style={{ padding: 0 }}>

                    <Container style={{ maxWidth: '98%' }}>
                        <h2 className="title text-center"> ข้อมูล คุณ {FullName} <a target="_blank" href={"/user/" + UserID} ><i className={(HN != null) ? "fas fa-user-cog mr-1" : "fas fa-user-plus mr-1"}></i></a> </h2>
                        
                        <p className="description text-center">HN {HN} </p>
                        <div className="text-center">
                            {
                                (FlowStatus != 0) ?
                                    <>
                                        <Button color="info" size="sm" val="1"
                                            style={{ paddingRight: '20px' }}
                                            onClick={handleCallNew}>
                                            <i className="fab fa-line" style={{ fontSize: '2em', color: 'white', verticalAlign: 'middle' }}></i> VDO Call ใหม่
                                        </Button>
                                        {/*
                                        <Button color="success" size="sm" val="1"
                                            style={{ paddingRight: '20px' }}
                                            onClick={handleLine}>
                                            <i className="fab fa-line" style={{ fontSize: '2em', color: 'white', verticalAlign: 'middle' }}></i> Video Call
                                        </Button>
                                        */}
                                    </>
                                    : ""
                            }
                            <UncontrolledDropdown className="btn-group">
                                <DropdownToggle
                                    aria-expanded={false}
                                    aria-haspopup={true}
                                    caret
                                    color="info"
                                    data-toggle="dropdown"
                                    type="button"
                                >
                                    ส่งต่อหน่วยงานอื่น
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem disabled={(FlowStatus >= 1 ? true : false)} href="#pablo" onClick={e => handleTransfer(e, 1)}>
                                        พยาบาล
                                  </DropdownItem>
                                    <DropdownItem disabled={(FlowStatus >= 2 ? true : false)} href="#pablo" onClick={e => handleTransfer(e, 2)}>
                                        แพทย์
                                  </DropdownItem>
                                    <DropdownItem disabled={(FlowStatus == -3 || FlowStatus >= 3 ? true : false)} href="#pablo" onClick={e => handleTransfer(e, -3)}>
                                        พยาบาลแจ้งยอดค่าใช้จ่าย
                                  </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>


                        <Row>
                            <Col className="ml-auto mr-auto" md="12" xl="6">
                                <Row>
                                    <Col className="text-left" md="12" xl="6">
                                        <p className="category">ข้อมูลทั่วไป</p>
                                        <p className="description text-center">Line: {LineProfile.displayName} </p>
                                        <p className="description text-center"><img style={{ width: 100, height: 100, borderRadius: 100 / 2 }} src={LineProfile.pictureUrl} /></p>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col className="text-center ml-auto mr-auto" md="12" xl="6">
                                        <FormGroup check className="form-check-radio" inline
                                            style={{ padding: '0', marginBottom: '10px' }}
                                        >
                                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                <Input
                                                    defaultValue="option1"
                                                    id="inlineRadio1"
                                                    name="ServiceType"
                                                    type="radio"
                                                    checked={(ServiceType == 1 ? true : false)}
                                                    onChange={e => setType(1)}
                                                ></Input>  พบแพทย์ <span className="form-check-sign"></span>
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check className="form-check-radio" inline>
                                            <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                                <Input
                                                    defaultValue="option2"
                                                    id="inlineRadio2"
                                                    name="ServiceType"
                                                    type="radio"
                                                    checked={(ServiceType == 2 ? true : false)}
                                                    onChange={e => setType(2)}
                                                ></Input>  รับยาต่อเนื่อง <span className="form-check-sign"></span>
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col className="ml-auto mr-auto" md="12" xl="6">
                                        <FormGroup
                                            style={{ padding: '0 0px', marginBottom: '10px' }}
                                            className={
                                                "input-lg" + (dateFocus ? " input-group-focus" : "")
                                            }
                                        >
                                            <i className="far fa-calendar-check fa-2x" style={{
                                                position: 'absolute',
                                                left: '12px',
                                                top: '15px',
                                                zIndex: 1,

                                            }}
                                            ></i>

                                            <Datetime
                                                value={moment(AppointDatetime)}
                                                renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                                isValidDate={e => e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1))}
                                                inputProps={{
                                                    name: "AppointDatetime", placeholder: "วันที่รับบริการ", readOnly: 'readonly', style: {
                                                        fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                    }
                                                }}
                                                closeOnSelect={true}
                                                closeOnTab={true}
                                                dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                                //onFocus={() => setDateFocus(true)}
                                                //onBlur={() => setDateFocus(false)}
                                                onChange={e => setDate(e.format('YYYY-MM-DD HH:mm'))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className="ml-auto mr-auto" md="12" xl="6">
                                        <TSText name="LineID" placeholder="Line ID" onChange={e => setLine(e.target.value)} value={LineID} icon="fab fa-line fa-2x" />
                                    </Col>
                                    <Col className="ml-auto mr-auto" md="12" xl="6">
                                        <TSText type="tel" maxLength="10" placeholder="โทรศัพท์" onChange={e => setPhone(e.target.value)} value={Phone} icon="fas fa-mobile-alt fa-2x" />
                                    </Col>

                                    <Col className="ml-auto mr-auto" md="12" xl="6">
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Address">ที่อยู่จัดส่งยา
                                              <Input
                                                    id="Address"
                                                    cols="80"
                                                    name="ShippingAddress"
                                                    placeholder="ที่อยู่จัดส่งยา"
                                                    rows="4"
                                                    type="textarea"
                                                    style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                    value={ShippingAddress}
                                                    onChange={e => setAddress(e.target.value)}
                                                ></Input></Label>
                                        </div>
                                    </Col>

                                    <Col className="ml-auto mr-auto" md="12" xl="6">
                                        <div className="textarea-container" style={{ padding: 0 }}>
                                            <Label for="Description">อาการเบื้องต้น
                                  <Input
                                                    id="Description"
                                                    cols="80"
                                                    name="Description"
                                                    placeholder="อาการเบื้องต้น"
                                                    rows="4"
                                                    type="textarea"
                                                    style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                    value={Description}
                                                    onChange={e => setDescription(e.target.value)}
                                                ></Input>
                                            </Label>
                                        </div>
                                    </Col>

                                    <Col className="ml-auto mr-auto" md="12" xl="6">


                                        <div className="send-button">

                                            <Button
                                                block
                                                className="btn-round"
                                                color="info"
                                                href="#pablo"
                                                size="lg"
                                                style={{ fontSize: '1.2em' }}
                                                onClick={handleSubmit}
                                            >
                                                แก้ไขข้อมูล
                                          </Button>

                                            {/* Confirm */}
                                            <Modal
                                                modalClassName="modal-mini modal-info"
                                                toggle={() => setModal2(false)}
                                                isOpen={modal2}
                                            >
                                                <div className="modal-header justify-content-center">
                                                    <div className="modal-profile">
                                                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                    </div>
                                                </div>
                                                <ModalBody>

                                                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังบันทึกข้อมูล"}</p>
                                                    <p>  </p>
                                                </ModalBody>
                                                <div className="modal-footer">
                                                    <Button
                                                        className="btn-neutral"
                                                        color="link"
                                                        type="button"
                                                        onClick={() => setModal2(false)}
                                                    >
                                                        ยกเลิก
                                      </Button>

                                                    <Button
                                                        className="btn-neutral"
                                                        color="link"
                                                        type="button"
                                                        onClick={handleConfirm}
                                                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                    //onClick={() => setModal2(false)}
                                                    >
                                                        ยืนยัน
                                      </Button>



                                                </div>
                                            </Modal>


                                            {/* Error */}
                                            <Modal
                                                modalClassName="modal-mini modal-danger"
                                                toggle={() => setModalError(false)}
                                                isOpen={modalError}
                                            >
                                                <div className="modal-header justify-content-center">
                                                    <div className="modal-profile">
                                                        <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                                    </div>
                                                </div>
                                                <ModalBody>
                                                    <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                                    <p> {errMsg} </p>
                                                </ModalBody>
                                                <div className="modal-footer justify-content-center">
                                                    <Button
                                                        className="btn-neutral"
                                                        color="neutral"
                                                        type="button"
                                                        onClick={() => setModalError(false)}
                                                    >
                                                        ตกลง
                                      </Button>
                                                </div>
                                            </Modal>


                                            <Modal
                                                modalClassName="modal-mini modal-info"
                                                toggle={() => setModalLine(false)}
                                                isOpen={modalLine}
                                            >
                                                <div className="modal-header justify-content-center">
                                                    <div className="modal-profile">
                                                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                    </div>
                                                </div>
                                                <ModalBody>

                                                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? modalMsg : "กำลังตรวจสอบข้อมูล"}</p>
                                                    <p>  </p>
                                                </ModalBody>
                                                <div className="modal-footer">
                                                    <Button
                                                        className="btn-neutral"
                                                        color="link"
                                                        type="button"
                                                        onClick={() => setModalLine(false)}
                                                    >
                                                        ยกเลิก
                                      </Button>

                                                    <Button
                                                        className="btn-neutral"
                                                        color="link"
                                                        type="button"
                                                        onClick={handleLineCall}
                                                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                    //onClick={() => setModal2(false)}
                                                    >
                                                        ยืนยัน
                                      </Button>



                                                </div>
                                            </Modal>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col className="ml-auto mr-auto" md="12" xl="6">
                                <p className="category">ข้อมูลที่สำคัญ</p>
                                <Card>
                                    <CardHeader>
                                        <Nav className="justify-content-center" role="tablist" tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={iconPills === "0" ? "active" : ""}
                                                    href="#"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setIconPills("0");
                                                    }}
                                                >
                                                    <i className="fas fa-images"></i> รูป
                                          </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={iconPills === "1" ? "active" : ""}
                                                    href="#pablo"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setIconPills("1");
                                                    }}
                                                >
                                                    <i className="fas fa-prescription-bottle-alt"></i> ค่าบริการ
                                          </NavLink>
                                            </NavItem>

                                            <NavItem>
                                                <NavLink
                                                    className={iconPills === "2" ? "active" : ""}
                                                    href="#pablo"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setIconPills("2");
                                                    }}
                                                >
                                                    <i className="fas fa-money-bill-wave"></i> การชำระเงิน
                                          </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={iconPills === "3" ? "active" : ""}
                                                    href="#pablo"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setIconPills("3");
                                                    }}
                                                >
                                                    <i className="fas fa-shipping-fast"></i> การจัดส่ง
                                          </NavLink>
                                            </NavItem>

                                        </Nav>
                                    </CardHeader>
                                    <CardBody>
                                        <TabContent
                                            className="text-center"
                                            activeTab={"iconPills" + iconPills}
                                        >
                                            <TabPane tabId="iconPills0">
                                                <section className="container text-center" style={{ border: '1px dashed', padding: '20px 0px' }}>
                                                    <aside style={thumbsContainer}>
                                                        {thumbs}
                                                    </aside>
                                                </section>
                                            </TabPane>
                                            <TabPane tabId="iconPills1">
                                                <Row style={{ fontWeight: 'bold', fontSize: '1em', borderBottom: '2px solid #dddddd' }}>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">
                                                        <Button onClick={reloadCost} ><i className="fas fa-sync-alt"></i></Button>
                                                    </Col>

                                                    <Col md="6" xs="6" className="d-none d-sm-block text-right">
                                                        {
                                                            (renderCost.length > 0 && (currentUser.role == 'Admin' || currentUser.role == 'Nurse')) ?
                                                                <Button color="success" onClick={handleCost} ><i className="fab fa-line" style={{ fontSize: '1.3rem' }}></i> แจ้งยอดค่าใช้จ่าย</Button>
                                                                :
                                                                <div></div>
                                                        }
                                                    </Col>
                                                </Row>

                                                <Row style={{ fontWeight: 'bold', fontSize: '1em', borderBottom: '2px solid #dddddd' }}>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">
                                                        รายการ
                                                  </Col>
                                                    <Col md="2" xs="2" className="d-none d-sm-block">
                                                        ยอดรวม
                                                  </Col>
                                                    <Col md="2" xs="2" className="d-none d-sm-block">
                                                        ใช้สิทธิ
                                                  </Col>
                                                    <Col md="2" xs="2" className="d-none d-sm-block">
                                                        ยอดจ่ายจริง
                                                  </Col>
                                                </Row>
                                                {contentCost}
                                                <Row style={{ fontSize: '1em', fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
                                                    <Col md="6" xs="6" className="text-left">
                                                        {(totalCost) ? totalCost.svname : ''}
                                                    </Col>
                                                    <Col md="2" xs="2">

                                                        {(totalCost) ? totalCost.totcost : ''}

                                                    </Col>
                                                    <Col md="2" xs="2">
                                                        {(totalCost) ? totalCost.netdisc : ''}

                                                    </Col>
                                                    <Col md="2" xs="2">
                                                        {(totalCost) ? totalCost.netcost : ''}

                                                    </Col>
                                                </Row>
                                                {/*
                                                <Row style={{ fontWeight: 'bold', fontSize: '1em', borderBottom: '2px solid #dddddd' }}>
                                                    <Col md="9" xs="9" className="d-none d-sm-block text-left">
                                                        รายการ
                                                  </Col>
                                                    <Col md="3" xs="3" className="d-none d-sm-block">
                                                        จำนวน
                                                  </Col>
                                                </Row>
                                                {contentDrug}
                                                */}
                                            </TabPane>
                                            <TabPane tabId="iconPills2">
                                                <Row style={{ fontWeight: 'bold', fontSize: '1em', borderBottom: '2px solid #dddddd' }}>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">

                                                    </Col>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-right">
                                                        {
                                                            (/*thumbsPay.length > 0 && */currentUser != null && (currentUser.role == 'Admin' || currentUser.role == 'Finance')) ?
                                                                <Button color="success" onClick={handlePayment} ><i className="fab fa-line" style={{ fontSize: '1.3rem' }}></i> ตรวจสอบการชำระเงิน</Button>
                                                                :
                                                                <div></div>
                                                        }
                                                    </Col>

                                                    <Modal
                                                        modalClassName="modal-mini modal-info"
                                                        toggle={() => setModalPayment(false)}
                                                        isOpen={modalPayment}
                                                    >
                                                        <div className="modal-header justify-content-center">
                                                            <div className="modal-profile">
                                                                <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                            </div>
                                                        </div>
                                                        <ModalBody>
                                                            <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการชำระเงิน" : "กำลังบันทึกข้อมูล"}</p>
                                                            <TSText type="text" placeholder="คำชี้แจง" onChange={e => setPaymentMsg(e.target.value)} value={PaymentMsg} />
                                                        </ModalBody>
                                                        <div className="modal-footer">
                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={() => setModalPayment(false)}
                                                            >
                                                                ยกเลิก
                                                          </Button>

                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={handleNoPay}
                                                            >
                                                                ปฏิเสธ
                                                          </Button>

                                                            <Button
                                                                className="btn-neutral"
                                                                color="link"
                                                                type="button"
                                                                onClick={e => handleTransfer(e, 5)}
                                                                disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                            >
                                                                ยืนยัน
                                                          </Button>
                                                        </div>
                                                    </Modal>

                                                </Row>
                                                {
                                                    <section className="container text-center" style={{ border: '1px dashed', padding: '20px 0px' }}>
                                                        <aside style={thumbsContainer}>
                                                            {thumbsPay}
                                                        </aside>
                                                    </section>
                                                }
                                            </TabPane>
                                            <TabPane tabId="iconPills3">
                                                <Row style={{ fontWeight: 'bold', fontSize: '1em' }}>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">

                                                    </Col>
                                                </Row>
                                                <section className="container text-center" style={{ border: '1px dashed', padding: '20px 0px' }}>
                                                    {trackList}
                                                </section>
                                        {
                                             ((FlowStatus == 5 || FlowStatus == 6) && (currentUser.role == 'Admin' || currentUser.role == 'Shipping')) ?
                                                <Row style={{ marginTop: '1.2em', fontWeight: 'bold', fontSize: '1em', borderBottom: '2px solid #dddddd' }}>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">
                                                                <TSText name="Tracking1" placeholder="Tracking No.#1" onChange={e => setTracking1(e.target.value)} value={Tracking1} icon="fas fa-shipping-fast" maxLength={13} />
                                                            </Col>
                                                    <Col md="6" xs="6" className="d-none d-sm-block text-left">
                                                                <TSText name="Tracking2" placeholder="Tracking No.#2" onChange={e => setTracking2(e.target.value)} value={Tracking2} icon="fas fa-shipping-fast" maxLength={13} />
                                                            </Col>
                                                    <Col md="12" xs="12" className="d-none d-sm-block text-left">
                                                        <Button color="success" onClick={handleTrack} ><i className="fas fa-shipping-fast" style={{ fontSize: '1.3rem' }}></i> บันทึก Tracking No.</Button>
                                                    </Col>
                                                    <Modal
                                                                modalClassName="modal-mini modal-info"
                                                                toggle={() => setModalTrack(false)}
                                                                isOpen={modalTrack}
                                                            >
                                                                <div className="modal-header justify-content-center">
                                                                    <div className="modal-profile">
                                                                        <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                                                    </div>
                                                                </div>
                                                                <ModalBody>

                                                                    <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการแจ้งเตือน Tracking No." : "กำลังบันทึกข้อมูล"}</p>
                                                                    <p>  </p>
                                                                </ModalBody>
                                                                <div className="modal-footer">
                                                                    <Button
                                                                        className="btn-neutral"
                                                                        color="link"
                                                                        type="button"
                                                                        onClick={() => setModalTrack(false)}
                                                                    >
                                                                        ยกเลิก
                                                            </Button>

                                                                    <Button
                                                                        className="btn-neutral"
                                                                        color="link"
                                                                        type="button"
                                                                        onClick={confirmTracking}
                                                                        disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                                                    //onClick={() => setModal2(false)}
                                                                    >
                                                                        ยืนยัน
                                                        </Button>



                                                                </div>
                                                            </Modal>
                                                </Row>
                                                :
                                                        <div className="text-danger" style={{ fontSize: '2em' }}>การเงินยังไม่ตรวจสอบ</div>
                                        }
                                                
                                            </TabPane>

                                        </TabContent>
                                    </CardBody>
                                </Card>
                            </Col>

                        </Row>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default TelePageInfo;
